import { render } from "./QuestionWording.vue?vue&type=template&id=ecca57de"
import script from "./QuestionWording.vue?vue&type=script&lang=js"
export * from "./QuestionWording.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__